import React, { Component } from "react";
import Modal from "react-modal";
import "../../common.css";
import { MdClose } from "react-icons/md";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import utilityFunctions from "../../../store/utilityFunctions";
import axios from "axios";
import Select from "react-select";
import AddNewDevice from "../../CustomerDetail/Devices/AddNewDevice/AddNewDevice";
import SetWarrantyDetails from "../../CustomerDetail/Devices/SetWarrantyDetails/SetWarrantyDetails";
// import { postNewStaffFunction } from "./api";

Modal.setAppElement("body");

const countryOptions = [
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zeland" },
];

export default class CustomerAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "",
      id: "",
      email: "",
      last_login: "",
      company: "",
      first_name: "",
      last_name: "",
      address_line_one: "",
      address_line_two: "",
      suburb: "",
      postcode: "",
      stateVal: "",
      suburbOptions: [],
      postcodeOptions: [],
      stateOptions: [],
      country: config.country,
      mobile: "",
      brand: "",
      postError: "",
      customerId: this.props.customerId || null,
      userDevice: null,
    };
  }

  componentDidMount() {
    this.retriveAllBrand();
    this.searchLocationState(config.country);
  }

  searchLocationState = (country) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "location/state/?country=" + country,
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((x) => {
          return { value: x.code, label: x.name };
        });
        this.setState({
          stateOptions: options,
        });
      })
      .catch(() => {
        // console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  searchLocationSuburb = (qState, qSuburb) => {
    this.setState({ loading: true });
    utilityFunctions
      .protectedFetch(
        config.backendServer +
          `location/suburb/?page_size=100&state=${qState}${
            qSuburb ? "&q=" + qSuburb : ""
          }`,
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.results.map((x) => {
          return { value: x.name, label: x.name };
        });
        console.log(options);
        this.setState({
          suburbOptions: options,
          // suburb: options[0].value,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };

  searchLocationPostcode = (qSuburb, qState) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer +
          "location/postcode/?suburb=" +
          qSuburb +
          "&state=" +
          qState,
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.results.map((x) => {
          return { value: x.code, label: x.code };
        });
        console.log(options);
        this.setState({
          postcodeOptions: options,
          // suburb: options[0].value,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      });
  };
  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  retriveAllRoles = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "roles/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, roles: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  handleSubmitNewCustomerDevice = (event) => {
    this.setState({ loading: true });
    event.preventDefault();
    this.props
      .protectedFetch(
        config.backendServer + `find/customers/`,
        "GET",
        { query_email: this.state.email },
        errorFunctions.checkResponseThenJson
      )
      .then(async (res) => {
        if (res.count > 0) {
          const customer = res?.results?.[0] || {};
          this.setState({
            loading: false,
            showModalReuseDeviceCustomer: true,
            isNewCustomer: true,
            customerId: customer.id,
            store_location: customer.store_location_id,
            customerName: [customer.first_name, customer.last_name]
              .filter(Boolean)
              .join(" "),
            messageModal: `Customer already exists. Would you like to register a new device?`,
          });
        } else {
          this.handleSubmit(event);
        }
      })
      .catch((e) => {
        console.log("fail", e);
        this.setState({ loading: false, isNewCustomer: false });
      });
  };

  postNewCustomer = (payload) => {
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";

    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return new Promise((resolve) => {
      axios
        .post(`${config.backendServer}customers/`, payload, options)
        .then((res) => {
          resolve(res);
          if (!this.props.isRegisterDevice) {
            this.props.handleCloseModal();
            this.props.handleRetrieveCustomerList();
            if (this.props.role === "Commercial Admin")
              window.location.href = "/customer-detail/" + res.data.id;
          }
        })
        .catch((err) => {
          this.setState({ postError: JSON.stringify(err.response?.data) });
          // this.props.handleCloseModal();
        });
      this.props.handleRetrieveCustomerList();
    });
  };

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();

    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");

    let payload = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      address_line_one: this.state.address_line_one,
      address_line_two: this.state.address_line_two,
      suburb: this.state.suburb,
      state: this.state.stateVal,
      mobile: this.state.mobile,
      postcode: this.state.postcode,
      country: this.state.country,
      brand: this.props.selectedBrandId,
      store_location: this.props.userInfo?.store_location_id,
    };

    if (this.props.isRegisterDevice) {
      payload = {
        ...payload,
        store_location: JSON.parse(userInfo)?.user?.store_location_id || null,
      };
    }

    const result = await this.postNewCustomer(payload);
    if (this.props.isRegisterDevice) {
      this.processNewCustomerDevice(result);
    } else {
      this.processGeneralNewCustomer(result);
    }
  };

  processNewCustomerDevice = (result) => {
    if (result.status === 200 || result.status === 201) {
      this.setState({
        loading: false,
        showModalReuseDeviceCustomer: false,
        openAddDevice: true,
        isCloseNewCustomer: false,
        customerId: result.data.id,
        customerName: result.data.first_name + " " + result.data.last_name,
        isNewCustomer: true,
      });
      alert("Customer created successfully.");
    } else {
      this.setState({
        loading: false,
        postError: JSON.stringify(result?.response?.data),
      });
    }
  };

  processGeneralNewCustomer = (result) => {
    if (result.status === 200 || result.status === 201) {
      this.setState({ loading: false });

      if (this.props.role === "Commercial Admin")
        setTimeout(
          () =>
            (window.location.href =
              "/customer-detail/" + result.response.data.id),
          2000
        );
      else this.props.handleRetrieveCustomerList();
      this.props.handleCloseModal();
    } else {
      this.setState({
        loading: false,
        postError: JSON.stringify(result?.response?.data),
      });
    }
  };

  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleCloseModalCustomer = () => {
    if (this.props.isRegisterDevice) {
      this.setState({
        openAddDevice: false,
        showModalReuseDeviceCustomer: true,
        messageModal:
          "You will lose all entered information. Are you sure you want to close?",
        isCloseNewCustomer: true,
        isNewCustomer: false,
        isCloseDeviceNew: false,
      });
    } else {
      this.props.handleCloseModal();
    }
  };

  handleConfirmModalDeviceCustomer = () => {
    const obj = {
      isNewCustomer: false,
      showModalReuseDeviceCustomer: false,
      isCloseNewCustomer: false,
    };

    if (this.state.isNewCustomer) {
      this.setState({
        ...obj,
        openAddDevice: true,
      });
    } else if (this.state.isCloseNewCustomer) {
      this.setState({
        ...obj,
        openAddDevice: false,
      });
      this.props.handleCloseModal();
    }

    if (this.state.isCloseDeviceNew) {
      this.setState({
        ...obj,
        showApproveModal: true,
      });
    }
  };

  render() {
    const countryValue = countryOptions.find(
      (x) => x.value === this.state.country
    );
    return (
      <div className={"card"} style={{ height: "100%" }}>
        <button
          onClick={this.handleCloseModalCustomer}
          className={"confirm-modal-close"}
        >
          <MdClose />
        </button>

        <h4 className={"card-header"}>Add Customer</h4>
        <form
          onSubmit={
            this.props.isRegisterDevice
              ? this.handleSubmitNewCustomerDevice
              : this.handleSubmit
          }
        >
          <div className="card-body">
            <div className="row mb-3">
              <div className={"col"}>
                <label
                  className={"single-warranty-details-label required"}
                  htmlFor="first_name"
                >
                  First name <span></span>
                </label>
                <input
                  type="text"
                  id="first_name"
                  required={true}
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
              <div className={"col"}>
                <label
                  className={"single-warranty-details-label required"}
                  htmlFor="last_name"
                >
                  Last name <span></span>
                </label>
                <input
                  type="text"
                  id="last_name"
                  required={true}
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className={"col"}>
                <label className={"single-warranty-details-label required"}>
                  Email<span></span>
                </label>

                <input
                  type="email"
                  id="email"
                  required={true}
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>
                  Mobile
                </label>

                <input
                  type="tel"
                  id="mobile"
                  //  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>
                  Address Line 1:
                </label>
                <textarea
                  id="address_line_one"
                  required={false}
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
              <div className={"col mb-3"}>
                <label className={"single-warranty-details-label "}>
                  Address Line 2:
                </label>
                <textarea
                  id="address_line_two"
                  required={false}
                  className="form-control"
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>
                  Country
                </label>
                <Select
                  isDisabled={
                    !["Admin"].includes(this.props.userInfo?.user?.role)
                  }
                  id={"deviceId"}
                  data-testid="assign-to-select"
                  value={countryValue}
                  options={countryOptions}
                  onChange={(obj) => {
                    this.setState({
                      country: obj.value,
                      stateVal: "",
                      suburb: "",
                      postcode: "",
                    });
                  }}
                />
              </div>
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>State</label>
                {this.state.country == "AU" ? (
                  <Select
                    required
                    options={this.state.stateOptions}
                    // onChange={() => alert("test")}
                    onChange={(obj) => {
                      this.setState({ stateVal: obj.value });
                      this.searchLocationSuburb(obj.value);
                    }}
                    // onInputChange={(val) => this.searchLocationState(val)}
                  />
                ) : (
                  <input
                    type="text"
                    id="stateVal"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.stateVal}
                  />
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>
                  Suburb
                </label>
                {this.state.country == "AU" ? (
                  <Select
                    required
                    options={this.state.suburbOptions}
                    onChange={(obj) => {
                      this.setState({ suburb: obj.value });
                      this.searchLocationPostcode(
                        obj.value,
                        this.state.stateVal
                      );
                    }}
                    onInputChange={(val) => {
                      if (val.length > 2)
                        this.searchLocationSuburb(this.state.stateVal, val);
                    }}
                  />
                ) : (
                  <input
                    type="text"
                    id="suburb"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.suburb}
                  />
                )}
              </div>
              <div className={"col"}>
                <label className={"single-warranty-details-label"}>
                  Postcode
                </label>
                {this.state.postcodeOptions.length > 0 ? (
                  <Select
                    required
                    options={this.state.postcodeOptions}
                    onChange={(obj) => this.setState({ postcode: obj.value })}
                  />
                ) : (
                  <input
                    type="text"
                    id="postcode"
                    required={true}
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.postcode}
                  />
                )}

                {/* <Select required options={this.state.postcodeOptions} onChange={(obj) => this.setState({ postcode: obj.value })} /> */}
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div className="row">
              <span className={"m-1 text-danger text-small"}>
                {this.state.postError}
              </span>
              <div className="col-2">
                <button className={"btn btn-outline-primary"}>Save</button>
              </div>
              <div className="col-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={this.handleCloseModalCustomer}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>

        <Modal
          isOpen={this.state.showModalReuseDeviceCustomer}
          contentLabel={"Modal Customer for Register Device"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() =>
                this.setState({ showModalReuseDeviceCustomer: false })
              }
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">
              <h6>{"Confirmation"}</h6>
            </div>
            <form>
              <div className="card-body text-center">
                <div>{this.state.messageModal}</div>
              </div>
              <div className="card-footer">
                <div className="row ">
                  <div className="col-6 text-right ">
                    <button
                      type="button"
                      className={"btn btn-outline-primary"}
                      onClick={this.handleConfirmModalDeviceCustomer}
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-6 text-left">
                    <button
                      type={"button"}
                      className={"btn btn-outline-secondary"}
                      onClick={() => {
                        this.setState({ showModalReuseDeviceCustomer: false });
                        if (this.state.isCloseDeviceNew) {
                          this.props.handleCloseModal();
                        }
                      }}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.openAddDevice}
          onRequestClose={() => this.setState({ openAddDevice: false })}
          contentLabel={"Add New Device."}
          className={"input-modal w-50 card "}
        >
          <div className="card-header">Add New Device</div>
          <button
            onClick={() => this.setState({ openAddDevice: false })}
            className={"info-modal-close"}
          >
            <MdClose />
          </button>
          <AddNewDevice
            protectedFetch={this.props.protectedFetch}
            selectedbrandID={this.props.selectedBrandId}
            customerId={this.state.customerId}
            handleCloseModal={() => {
              this.setState({ openAddDevice: false, isCloseDeviceNew: false });
              this.props.handleCloseModal();
            }}
            handleSuccessfulAddNewDevice={(device) => {
              this.setState({
                openAddDevice: false,
                showModalReuseDeviceCustomer: true,
                messageModal: `${device?.device?.name} has already been registered to ${this.state.customerName}. Would you like to raise an RMA ticket for this device?`,
                showApproveModal: false,
                userDevice: device?.id || null,
                isCloseDeviceNew: true,
              });
              this.props.handleRefresh();
            }}
            handleRefresh={() => this.props.handleRefresh()}
            userInfo={this.props.userInfo}
            isRegisterDevice={this.props.isRegisterDevice}
          />
        </Modal>

        {/* Modal form for approving warranty form */}
        <SetWarrantyDetails
          userDevice={this.state.userDevice}
          customerId={this.state.customerId}
          protectedFetch={this.props.protectedFetch}
          showModal={this.state.showApproveModal}
          hideModal={() => {
            this.setState({ showApproveModal: false });
            this.props.handleCloseModal();
          }}
          retrieveDevicesNew={this.retrieveDevicesNew}
          handleRefresh={() => this.props.handleRefresh()}
          isRegisterDevice={this.props.isRegisterDevice}
          selectedbrandID={this.props.selectedBrandId}
        />
      </div>
    );
  }
}
